var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SlidingPage',{attrs:{"open":_vm.open},on:{"close":_vm.closeTag},scopedSlots:_vm._u([{key:"container",fn:function(){return [(_vm.open && _vm.page === 'game-detail' && _vm.id)?_c('GameView',{attrs:{"id":_vm.id}}):_vm._e(),(_vm.open && _vm.page === 'game-ks-detail' && _vm.id)?_c('GameKsPage',{attrs:{"id":_vm.id}}):_vm._e()]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }